import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Flex, Image, mode, Text, useColorMode } from '@abb/uikit';
import dayjs from 'dayjs';
import { useCampaignsRead } from 'hooks';
import React from 'react';
export function CampaignItem(param) {
    let { item, mutate, onDetailModalOpen } = param;
    const { colorMode } = useColorMode();
    const { read } = useCampaignsRead(item === null || item === void 0 ? void 0 : item.id);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(Flex, {
            onClick: ()=>{
                onDetailModalOpen();
                read(mutate);
            },
            py: 3,
            h: "352px",
            justifyContent: "space-between",
            color: mode('black', 'white')({
                colorMode
            }),
            children: [
                /*#__PURE__*/ _jsx(Box, {
                    children: /*#__PURE__*/ _jsxs(Flex, {
                        children: [
                            /*#__PURE__*/ _jsx(Box, {
                                borderRadius: "99px",
                                w: "6px",
                                h: "6px",
                                bg: !item.read ? 'red' : 'gray',
                                m: 2
                            }),
                            /*#__PURE__*/ _jsxs(Box, {
                                alignItems: "center",
                                m: 0,
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        fontWeight: 600,
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        color: mode('#484A4F', '#C4C7CC')({
                                            colorMode
                                        }),
                                        fontSize: "14px",
                                        maxW: "200px",
                                        children: item.content
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        color: "#7A7D82",
                                        mt: 2,
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        children: dayjs(item.publishDate, 'YYYY-MM-DD').format('DD MMMM YYYY')
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Flex, {
                    w: "48px",
                    h: "48px",
                    borderRadius: "12px",
                    children: /*#__PURE__*/ _jsx(Image, {
                        border: `1px solid ${mode('#0A0B0D1F', '#FFFFFF1F')({
                            colorMode
                        })}`,
                        borderRadius: "12px",
                        width: "100%",
                        height: "100%",
                        src: 'data:;base64,' + item.imageFile
                    })
                })
            ]
        }, item === null || item === void 0 ? void 0 : item.id)
    });
}
